import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { HeadingWrap, Span } from '../../../Styles/CommonStyles';
import CompSentboxTable from './CompSentboxTable';
import ComplaintDetails from '../ComplaintDetails';
import { useGetComplaintsQuery } from '../../../features/complaints/complaintsApiSlice';

const Container = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`;

const Wrapper = styled.div``;

const CompSentbox = ({ subTabValue }) => {
  const [row, setRow] = useState('');
  const [changepage, setChangepage] = useState([true, false, false, false, false]);

  // Get complaints data to find full complaint details by ID
  const { complaints } = useGetComplaintsQuery("complaints", {
    selectFromResult: ({ data }) => ({
      complaints: data?.entities
    }),
  });

  const handleEditclick = async (e, rowData, reqtype) => {
    console.log('Complaint sentbox reqtype:', reqtype);
    console.log('Row data received:', rowData);
    
    // Find full complaint data if only ID is provided
    let fullComplaintData = rowData;
    if (rowData?._id && complaints && !rowData.complaintNo) {
      fullComplaintData = complaints[rowData._id] || rowData;
    }
    
    setRow(fullComplaintData);
  
    if (["ViewComplaint", "ProcessComplaint"].includes(reqtype)) {
      setChangepage([false, true, false, false, false]);
    } else if (["ComplaintDetails"].includes(reqtype)) {
      setChangepage([false, false, true, false, false]);
    } else if (reqtype === "direct") {
      setChangepage([false, false, false, false, true]);
    }
  };
  
  return (
    <Container>
      <Wrapper>
        {(changepage[0]) && <CompSentboxTable subTabValue={subTabValue} handleEditclick={handleEditclick} />}
        {(changepage[1]) && <ComplaintDetails row={row} subTabValue={subTabValue} setChangepage={setChangepage} />}
        {/* Additional complaint detail components can be added here */}
      </Wrapper>
    </Container>
  );
};

export default CompSentbox; 